export const environment = {
  production: true,
  debugMode: true,
  ENVIRONMENT: 'dev',
  registerServiceWorker: true,
  sentryDSN: 'https://a40e8719561d497aa04f7fbec1489d21@errcol.g.placewise.com/4',
  sentryEnvironment: 'dev',
  commitId: '41882743f2f1b5f1415516df0ba5edeee9fed643',
  webforms_api: '/api',
  passwordMinLength: 8,
  dmpEvents: true,
  recaptchaBaseKey: '6LcVLSwdAAAAAFdAdLYMetuwSOz_qnQZ8_wTJGM_',
  recaptchaCheckboxKey: '6LfGyzcdAAAAAOSE24RnK9P4bzGjyEadx3RLJ6Bd',
  authApi: '/v1',
  mobileEventsDebugEnabled: false,
};
